import { Trans } from '@lingui/react/macro';

export const FullSize = ({ size }) => {
  if (size === 'STK') return <Trans>Sticker</Trans>;
  const type = getType(size);
  switch (size.substring(0, 1)) {
    case 'F':
    case 'P':
      return type;
    case 'T':
      return getTanksSize(size, type);
    case 'K':
      return (
        <>
          {type} {getKidsSize(size)}
        </>
      );
    default:
      return (
        <>
          {type} {getSize(size)}
        </>
      );
  }
};

function getType(size) {
  if (isPullover(size)) return <Trans>Pullover Hoodie</Trans>;
  if (isMan(size)) return <Trans>Man</Trans>;
  switch (size.substring(0, 1)) {
    case 'W':
      return <Trans>Woman</Trans>;
    case 'K':
      return <Trans>Kids</Trans>;
    case 'H':
      return <Trans>Hoodie</Trans>;
    case 'S':
      return <Trans>Sweater</Trans>;
    case 'T':
      return <Trans>Tank</Trans>;
    case 'F':
      return <Trans>Facemask</Trans>;
    case 'P':
      return <Trans>Print</Trans>;
    default:
      return size;
  }
}

function getSizeLetter(size) {
  if (isPullover(size)) return size.substring(2);
  if (isMan(size)) return size;
  return size.substring(1);
}

function getSize(size) {
  size = getSizeLetter(size);
  switch (size) {
    case 'S':
      return <Trans>Small</Trans>;
    case 'M':
      return <Trans>Medium</Trans>;
    case 'L':
      return <Trans>Large</Trans>;
    case 'XL':
      return <Trans>Extra Large</Trans>;
    case 'XXL':
      return <Trans>XXL</Trans>;
    case '3XL':
      return <Trans>3XL</Trans>;
    default:
      return size.substring(1);
  }
}

function getTanksSize(size, type) {
  switch (size.substring(1, 2)) {
    case 'W':
      return (
        <>
          <Trans>Woman</Trans> {type} {getSize(size.substring(1))}
        </>
      );
    default:
      return (
        <>
          <Trans>Man</Trans> {type} {getSize(size)}
        </>
      );
  }
}

function getKidsSize(size) {
  switch (size.substring(1)) {
    case 'M':
      return <Trans>M: Age 6-8</Trans>;
    case 'L':
      return <Trans>L: Age 9-11</Trans>;
    case 'XL':
      return <Trans>XL: Age 12-14</Trans>;
    default:
      return size.substring(1);
  }
}

function isPullover(size) {
  return ['PHS', 'PHM', 'PHL', 'PHXL', 'PHXXL'].includes(size);
}

function isMan(size) {
  return ['S', 'M', 'L', 'XL', 'XXL', '3XL'].includes(size);
}
